import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import { Box, Typography } from '@mui/material';

/**
 * The component to show when initialization has failed.
 */
const InitFailed = () => (
  <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
    <ErrorOutlineRoundedIcon color="error" style={{ fontSize: 60 }} />
    <Box display="flex" flexDirection="column" alignItems="center">
      <Typography fontWeight="bold" fontSize="1.5em" textAlign="center">
        Failed to Initialize
      </Typography>
      <Typography color="textSecondary" textAlign="center" gutterBottom>
        We failed to initialize the add licenses. Please try again. If this
        continues, contact support.
      </Typography>
    </Box>
  </Box>
);

export default InitFailed;
